import { Component, OnInit } from '@angular/core';
import { CitaService } from '../components/simple-page/services/cita.service';
import { ActivatedRoute } from '@angular/router';
import { BaseResponse } from '../shared/models/base-api-response.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-confirmar-turnos',
  templateUrl: './confirmar-turnos.component.html',
  styleUrls: ['./confirmar-turnos.component.scss']
})
export class ConfirmarTurnosComponent implements OnInit {

  turno: number;
  hc: number;
  infoTurno: {
    practica: string;
    observacion: string;
    profesional: string;
    paciente: string;
    email: string;
    especialidad: string;
    fecha: string;
    hora: string;
    numero: number;
  }[] = [];
  message: boolean = false;
  messageWhatsapp: string;

  constructor(
    private _citaService: CitaService,
    private _route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    const idTurno = this._route.snapshot.paramMap.get('idTurno');
    this.turno = parseInt(idTurno);
    this.obtenerInfoTurno(this.turno);
  }

  obtenerInfoTurno(turno: number) {
    this._citaService.InformacionCitaWhatsapp(turno).subscribe({
      next: (data: BaseResponse) => {
        if (data.isSuccess) {
          this.infoTurno = data.data;
        } else {
          // Swal.fire('Oops!', data.message, 'info');
          this.message = true;
          this.messageWhatsapp = data.message;
        }
      },
      error: (error) => {
        Swal.fire('Algo salió mal', error, 'warning');
      }
    });
  }

  confirmarTurno(turno: number) {
    this._citaService.ConfirmarCita(turno).subscribe({
      next: (data: BaseResponse) => {
        if (data.isSuccess) {
          this.message = true;
          Swal.fire('¡Confirmado!', 'Muchas gracias por su tiempo.', 'success');
        } else {
          Swal.fire('Oops', data.message, 'info');          
        }
      },
      error: (error) => {
        Swal.fire('Algo salió mal', error, 'warning');
      }
    });
  }

  cancelarTurno(turno: number) {
    Swal.fire({
      title: "¿Está seguro?",
      text: "Si cancela el turno, no se podrá revertir.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, Cancelar",
      cancelButtonText: "No, Volver"
    }).then((result) => {
      if (result.isConfirmed) {
        this._citaService.CancelarCita(turno).subscribe({
          next: (data: BaseResponse) => {
            if (data.isSuccess) {
              this.message = true;
              Swal.fire('¡Cancelado!', 'Muchas gracias por su tiempo.', 'success');
            } else {
              Swal.fire('Oops', data.message, 'info');          
            }
          },
          error: (error) => {
            Swal.fire('Algo salió mal', error, 'warning');
          }
        });
      }
    });    
  }

}
